// Modification provided by Searchanise team. With any questions, contact us at feedback@searchanise.io

document.addEventListener('Searchanise.Loaded', function() {

    // SETTINGS START

    /*
    Value translations are identical regardless of which filter a value appears under (verified:
    no value has conflicting translations across filters), so each locale defines ONE shared value
    dictionary below. Every filter title for that locale points at that shared dictionary, keyed by
    both the English title and its localised title so lookups succeed whether Searchanise returns a
    translated or fall-back (English) facet title. To add/adjust a translation, edit the *_values
    map for the locale.
    */

    const it_values = {
        "2-5": "35-38",
        "2XL": "2XL",
        "6 3/8": "6 3/8",
        "6-8": "39-42",
        "7": "7",
        "7 1/2": "7 1/2",
        "7 1/4": "7 1/4",
        "7 1/8": "7 1/8",
        "7 3/4": "7 3/4",
        "7 3/8": "7 3/8",
        "7 5/8": "7 5/8",
        "7 7/8": "7 7/8",
        "8": "8",
        "9-11": "43-46",
        "A-Frame": "A-Frame",
        "AC Milan": "AC Milan",
        "Adjustable": "Regolabile",
        "American Football": "Football Americano",
        "Anorak": "Anorak",
        "AS Roma": "AS Roma",
        "Bags": "Borse",
        "Balaclava": "Balaclava",
        "Baseball": "Baseball",
        "Basketball": "Basketball",
        "Beige": "Beige",
        "Beret": "Beret",
        "Black": "Nero",
        "Blue": "Blu",
        "Bomber Jacket": "Giacca Bomber",
        "Borg": "Borg",
        "Boucle": "Boucle",
        "Box Fit": "Taglio boxy",
        "Boxing": "Box",
        "Brown": "Marrone",
        "Buckets": "Buckets",
        "Button": "Bottoni",
        "Buttons": "Bottoni",
        "Camo": "Camo",
        "Cap Care": "Cura del Cappello",
        "Cap Carriers": "Porta Cappelli",
        "Cap Clips": "Clips",
        "Cardigan": "Cardigan",
        "Cargo Joggers": "Joggers Cargo",
        "Cargo Shorts": "Pantaloncini Cargo",
        "Cargo Trousers": "Pantaloni Cargo",
        "Casual Classic": "Casual Classic",
        "Chelsea F.C.": "Chelsea FC",
        "Child": "Bambino (4-6 anni)",
        "Chino Shorts": "Pantaloncini in chino",
        "Chinos": "Pantaloni in chino",
        "Coach Jacket": "Giacca Coach",
        "Cord": "Tessuto a coste",
        "Cotton Shorts": "Pantaloncini in cotone",
        "Cream": "Crema",
        "Cricket": "Cricket",
        "Cuffed Joggers": "Joggers con orlo",
        "Curved": "Curva",
        "Cycling Shorts": "Pantaloncini da ciclista",
        "Denim Jacket": "Giacca in denim",
        "Denim Shorts": "Pantaloncini in denim",
        "Denim Trousers": "Pantaloni in denim",
        "Drawstring": "Cordino",
        "Dress": "Abiti",
        "Dresses": "Vestiti",
        "Ducati": "Ducati",
        "E-Frame": "E-Frame",
        "Earmuffs": "Paraorecchie",
        "Elasticated": "Elasticizzata",
        "Faux Fur": "Pelliccia sintetica",
        "Faux Suede": "Scamosciato sintetico",
        "Female": "Donna",
        "Fitted": "Fitted",
        "Flat": "Piatta",
        "Football": "Calcio",
        "French Federation Of Rugby": "French Federation Of Rugby",
        "Full Zip": "Con zip",
        "Gilet": "Gilet",
        "Gloves": "Guanti",
        "Golf": "Golf",
        "Green": "Verde",
        "Grey": "Grigio",
        "Headband": "Fasce",
        "Headwear": "Cappelli",
        "Heavy Twill": "Twill",
        "Hockey": "Hockey",
        "Hoodie": "Felpe",
        "Hoodies & Sweatshirts": "Felpe",
        "Infant": "Neonato (0-2 anni)",
        "Jackets & Coats": "Giacche & Giubbotti",
        "Jogger Shorts": "Pantaloncini Jogger",
        "Joggers": "Joggers",
        "Key Rings": "Portachiavi",
        "Kids": "Bambino",
        "Knits": "Berretti",
        "Knitted Jumper": "Maglioni lavorati a maglia",
        "Knitted Jumpers & Cardigans": "Maglioni & Cardigan",
        "L": "L",
        "L-XL": "L-XL",
        "Leather": "Vera pelle",
        "Leggings": "Leggings",
        "Linen": "Lino",
        "Long": "Lunga",
        "Lounge Wear": "Lounge Wear",
        "Low Profile": "Low Profile",
        "M": "M",
        "M-L": "M-L",
        "Male": "Uomo",
        "Manchester United F.C.": "Manchester United FC",
        "McLaren Formula 1 Team": "McLaren Racing",
        "Melton Wool": "Lana Melton",
        "Merino Wool": "Lana Melton",
        "Mesh": "Tessuto a rete",
        "Mesh Shorts": "Pantaloncini in mesh",
        "Misc": "Misc",
        "MLB Logo": "MLB Logo",
        "MoneyGram Haas F1 Team": "MoneyGram Haas F1 Team",
        "Motor Racing": "Motor Racing",
        "NBA Logo": "NBA Logo",
        "NFL Logo": "NFL Logo",
        "No Visor": "Altri Stili",
        "One Size": "Taglia Unica",
        "Orange": "Arancione",
        "Other": "Altro",
        "Oversized": "Oversized",
        "Parka Jacket": "Giacca Parka",
        "Pin Badges": "Spille",
        "Pink": "Rosa",
        "Polo Shirt": "Polo",
        "Ponytail Caps": "Open-back",
        "Popper": "Bottoni automatici",
        "Portuguese Football Federation": "Portuguese Football Federation",
        "PU": "PU",
        "Puffer Jacket": "Giacca Puffer",
        "Purple": "Viola",
        "Quarter Zip": "Zip su colletto",
        "Red": "Rosso",
        "Regular": "Regular",
        "Repreve": "Repreve",
        "Ripstop": "Ripstop",
        "Rugby": "Rugby",
        "Rugby Football Union": "Rugby Football Union",
        "Rugby Shirt": "Maglie Rugby",
        "Runner": "Runner",
        "S": "S",
        "S-M": "S-M",
        "Satin": "Raso",
        "Scarves": "Sciarpe",
        "Shacket": "Shacket",
        "Sherpa Jacket": "Giacca in sherpa",
        "Shirt": "Maglia",
        "Short": "Corta",
        "Shorts": "Pantaloncini",
        "Skirt": "Gonna",
        "Skull Beanie": "Berretti",
        "Sleeveless": "Smanicato",
        "Socks": "Calze",
        "Split Panel": "Split Panel",
        "Sports Jersey": "Jersey sportive",
        "Sports Shorts": "Pantaloncini sportivi",
        "Straight Leg Joggers": "Joggers Straight Leg",
        "Stretch Fit": "Stretch Fit",
        "Suede": "Scamosciato",
        "Sunglasses": "Occhiali da Sole",
        "Sweatshirts": "Felpa a girocollo",
        "Swim Shorts": "Costumi da bagno",
        "T-Shirts": "T-Shirts",
        "T-Shirts & Vests": "T-Shirts",
        "Tank Top": "Top",
        "Toddler": "Bambino (2-4 anni)",
        "Track Jacket": "Giacca Track",
        "Tracksuits": "Tute",
        "Trapper": "Trapper",
        "Trousers": "Pantaloni",
        "Trucker": "Trucker",
        "Umbrellas": "Ombrelli",
        "Varsity Jacket": "Giacca Varsity",
        "Velour": "Velluto",
        "Visa Cash App Racing Bulls": "Visa Cash App RB Formula1 Team",
        "Visor Caps": "Visiere",
        "VR46": "VR46",
        "White": "Bianco",
        "Windbreaker": "Antivento",
        "Wool": "Lana",
        "XL": "XL",
        "XS": "XS",
        "XS-S": "XS-S",
        "Yellow": "Giallo",
        "Youth": "Ragazzo (6-12 anni)",
        "Zip": "Zip",
    };

    const de_values = {
        "2-5": "35-38",
        "2XL": "2XL",
        "6 3/8": "6 3/8",
        "6-8": "39-42",
        "7": "7",
        "7 1/2": "7 1/2",
        "7 1/4": "7 1/4",
        "7 1/8": "7 1/8",
        "7 3/4": "7 3/4",
        "7 3/8": "7 3/8",
        "7 5/8": "7 5/8",
        "7 7/8": "7 7/8",
        "8": "8",
        "9-11": "43-46",
        "A-Frame": "A-Frame",
        "AC Milan": "AC Milan",
        "Adjustable": "Verstellbar",
        "American Football": "American Football",
        "Anorak": "Anorak",
        "AS Roma": "AS Roma",
        "Bags": "Taschen",
        "Balaclava": "Balaclava",
        "Baseball": "Baseball",
        "Basketball": "Basketball",
        "Beige": "Beige",
        "Beret": "Beret",
        "Black": "Schwarz",
        "Blue": "Blau",
        "Bomber Jacket": "Bomber Jacke",
        "Borg": "Borg",
        "Boucle": "Boucle",
        "Box Fit": "Boxy Fit",
        "Boxing": "Boxing",
        "Brown": "Braun",
        "Buckets": "Bucket Hats",
        "Button": "Knopfverschluss",
        "Buttons": "Knopfleiste",
        "Camo": "Camo",
        "Camper": "Camper",
        "Cap Care": "Cap Care",
        "Cap Carriers": "Cap Carriers",
        "Cap Clips": "Cap Clips",
        "Cardigan": "Cardigan",
        "Cargo Joggers": "Cargo Jogger",
        "Cargo Shorts": "Cargo Shorts",
        "Cargo Trousers": "Cargohosen",
        "Casual Classic": "Casual Classic",
        "Chelsea F.C.": "Chelsea FC",
        "Child": "Kind (4-6)",
        "Chino Shorts": "Chino Shorts",
        "Chinos": "Chinos",
        "Coach Jacket": "Coach Jacken",
        "Cord": "Cord",
        "Cotton Shorts": "Baumwollshorts",
        "Cream": "Hellbeige",
        "Cricket": "Cricket",
        "Cuffed Joggers": "Cuffed Joggers",
        "Curved": "Gebogener Schirm",
        "Cycling Shorts": "Radlerhosen",
        "Denim Jacket": "Denim Jacken",
        "Denim Shorts": "Denim Shorts",
        "Denim Trousers": "Denim Hosen",
        "Docker": "Dockermütze",
        "Dogear": "Dogear",
        "Dogear Caps": "Dogear",
        "Drawstring": "Kordelzug",
        "Dress": "Kleider",
        "Dresses": "Kleider",
        "Ducati": "Ducati",
        "E-Frame": "E-Frame",
        "Earmuffs": "Earmuffs",
        "Elasticated": "Elastisch",
        "Faux Fur": "Kunstpelz",
        "Faux Suede": "Kunstleder",
        "Female": "Damen",
        "Fitted": "Fitted",
        "Flat": "Flacher Schirm",
        "Football": "Fußball",
        "French Federation Of Rugby": "French Federation of Rugby",
        "Full Zip": "Reißverschlussjacken",
        "Gilet": "Weste",
        "Gloves": "Handschuhe",
        "Golf": "Golf",
        "Green": "Grün",
        "Grey": "Grau",
        "Headband": "Kopfband",
        "Heavy Duty Trousers": "Heavy Duty Hosen",
        "Heavy Twill": "Twill",
        "Hockey": "Hockey",
        "Hoodie": "Hoodie",
        "Hoodies & Sweatshirts": "Hoodies & Pullover",
        "Infant": "Baby (0-2)",
        "Jackets & Coats": "Jacken & Mäntel",
        "Jogger Shorts": "Jogger Shorts",
        "Joggers": "Jogginghosen",
        "Key Rings": "Schlüsselanhänger",
        "Kids": "Kinder",
        "Knits": "Mützen",
        "Knitted Jumper": "Strickpullover",
        "L": "L",
        "L-XL": "L-XL",
        "Leather": "Leder",
        "Leggings": "Leggings",
        "Linen": "Leinen",
        "Long": "Lang",
        "Lounge Wear": "Loungewear",
        "Low Profile": "Low Profile",
        "M": "M",
        "M-L": "M-L",
        "Male": "Herren",
        "Manchester United F.C.": "Manchester United FC",
        "McLaren Formula 1 Team": "McLaren Racing",
        "Melton Wool": "Melton Wolle",
        "Merino Wool": "Merino Wolle",
        "Mesh": "Mesh",
        "Mesh Shorts": "Mesh Shorts",
        "Misc": "Extras",
        "MLB Logo": "MLB Logo",
        "MoneyGram Haas F1 Team": "MoneyGram Haas F1 Team",
        "Motor Racing": "Motorsport",
        "NBA Logo": "NBA Logo",
        "Newsboy": "Schiebermütze",
        "NFL Logo": "NFL Logo",
        "No Visor": "Ohne Schirm",
        "One Size": "Einheitsgröße",
        "Orange": "Orange",
        "Other": "Sonstiges",
        "Oversized": "Oversized",
        "Parka Jacket": "Parka",
        "Pin Badges": "Pin Badges",
        "Pink": "Pink",
        "Polo Shirt": "Poloshirt",
        "Ponytail Caps": "Open Back",
        "Popper": "Druckknöpfe",
        "Portuguese Football Federation": "Portuguese Football Federation",
        "PU": "PU",
        "Puffer Jacket": "Pufferjacken",
        "Purple": "Lila",
        "Quarter Zip": "Quarter Zip",
        "Red": "Rot",
        "Regular": "Regulär",
        "Repreve": "Repreve",
        "Retro Crown": "Retro Crown",
        "Ripstop": "Ripstop",
        "Rugby": "Rugby",
        "Rugby Football Union": "Rugby Football Union",
        "Rugby Shirt": "Rugby Shirt",
        "Runner": "Runner Cap",
        "S": "S",
        "S-M": "S-M",
        "Satin": "Satin",
        "Scarves": "Schals",
        "Shacket": "Shacket",
        "Sherpa Jacket": "Fleece Jacken",
        "Shirt": "Shirts",
        "Short": "Kurz",
        "Shorts": "Shorts",
        "Skirt": "Röcke",
        "Skull Beanie": "Skull Beanie",
        "Sleeveless": "Ärmellos",
        "Socks": "Socken",
        "Split Panel": "Split Panel",
        "Sports Jersey": "Sport Jersey",
        "Sports Shorts": "Sport Shorts",
        "Straight Leg Joggers": "Straight Leg Jogger",
        "Stretch Fit": "Stretch",
        "Stretch Snap": "Stretch Snap",
        "Suede": "Wildleder",
        "Sunglasses": "Sonnenbrillen",
        "Sweatshirts": "Sweatshirts",
        "Swim Shorts": "Badehosen",
        "T-Shirts": "T-Shirts",
        "T-Shirts & Vests": "T-Shirts & Tank Tops",
        "Tank Top": "Tank Tops",
        "Toddler": "Kleinkind (2-4)",
        "Track Jacket": "Track Jacken",
        "Tracksuits": "Trainingsanzüge",
        "Trapper": "Trapper",
        "Trousers": "Hosen",
        "Trucker": "Trucker",
        "Varsity Jacket": "Collegejacken",
        "Velour": "Velour",
        "Visa Cash App Racing Bulls": "Visa Cash App RB Formula1 Team",
        "Visor Caps": "Schirm Cap",
        "VR46": "VR46",
        "White": "Weiß",
        "Windbreaker": "Windbreaker",
        "Windrunner": "Windrunner",
        "Wool": "Wolle",
        "Woven Shorts": "Gewebte Shorts",
        "XL": "XL",
        "XS": "XS",
        "XS-S": "XS-S",
        "Yellow": "Gelb",
        "Youth": "Jugend (6-12)",
        "Zip": "Reißverschluss",
    };

    const es_values = {
        "2-5": "35 - 38",
        "6-8": "39 - 42",
        "9-11": "43 - 46",
        "A-Frame": "A-Frame",
        "AC Milan": "AC Milan",
        "Adjustable": "Ajustable",
        "American Football": "Fútbol Americano",
        "AS Roma": "AS Roma",
        "Bags": "Bolsos",
        "Balaclava": "Balaclava",
        "Baseball": "Béisbol",
        "Basketball": "Baloncesto",
        "Beige": "Beige",
        "Beret": "Boina",
        "Black": "Negro",
        "Blue": "Azul",
        "Borg": "Borreguillo",
        "Boucle": "Bouclé",
        "Boxing": "Boxeo",
        "Brown": "Marrón",
        "Buckets": "Gorro Pescador",
        "Camo": "Camuflaje",
        "Camper": "Camper",
        "Cap Care": "Cuidado de Gorras",
        "Cap Carriers": "Porta Gorras",
        "Cap Clips": "Clips para gorras",
        "Casual Classic": "Classic",
        "Chelsea F.C.": "Chelsea FC",
        "Child": "4-6 años",
        "Cord": "Pana",
        "Cream": "Crema",
        "Cricket": "Cricket",
        "Curved": "Curvada",
        "Docker": "Docker",
        "Dogear": "Gorra Dogear",
        "Dogear Caps": "Gorras Dogear",
        "Dresses": "Vestidos",
        "Ducati": "Ducati",
        "E-Frame": "E-Frame",
        "Earmuffs": "Orejeras",
        "Faux Fur": "Piel sintética",
        "Faux Suede": "Ante sintético",
        "Female": "Mujer",
        "Fitted": "Fitted",
        "Flat": "Plana",
        "Football": "Fútbol",
        "French Federation Of Rugby": "Federación Francesa de Rugby",
        "Gloves": "Guantes",
        "Green": "Verde",
        "Grey": "Gris",
        "Headband": "Diadema",
        "Headwear": "Gorras y Gorros",
        "Heavy Twill": "Tela de sarga pesada",
        "Hoodies & Sweatshirts": "Sudaderas",
        "Infant": "0-2 años",
        "Jackets & Coats": "Chaquetas y Abrigos",
        "Joggers": "Pantalones Joggers",
        "Key Rings": "Llaveros",
        "Kids": "Niños",
        "Knits": "Gorro",
        "Leather": "Cuero",
        "Leggings": "Leggins",
        "Linen": "Lino",
        "Lounge Wear": "Ropa loungewear",
        "Low Profile": "Low Profile",
        "Male": "Hombre",
        "Manchester United F.C.": "Manchester United FC",
        "McLaren Formula 1 Team": "McLaren Racing",
        "Melton Wool": "Lana melton",
        "Merino Wool": "Lana merino",
        "Mesh": "Rejilla",
        "Misc": "Varios",
        "MLB Logo": "MLB Logo",
        "MoneyGram Haas F1 Team": "MoneyGram Haas F1 Team",
        "Motor Racing": "Automovilismo",
        "NBA Logo": "NBA Logo",
        "Newsboy": "Gorras Newsboy",
        "NFL Logo": "NFL Logo",
        "No Visor": "Otros",
        "One Size": "Talla Única",
        "Orange": "Naranja",
        "Other": "Otros",
        "Pin Badges": "Pins",
        "Pink": "Rosa",
        "Ponytail Caps": "Gorras para coleta",
        "Portuguese Football Federation": "Federación Portuguesa de Fútbol",
        "PU": "Poliuretano",
        "Purple": "Lila",
        "Red": "Rojo",
        "Repreve": "Repreve",
        "Retro Crown": "Retro Crown",
        "Ripstop": "Ripstop",
        "Rugby": "Rugby",
        "Rugby Football Union": "Rugby Football Union",
        "Runner": "Runner",
        "Satin": "Satinado",
        "Scarves": "Bufandas",
        "Shorts": "Pantalón Corto",
        "Skull Beanie": "Gorro Skull",
        "Socks": "Calcetines",
        "Split Panel": "Split Panel",
        "Stretch Fit": "Stretch Fit",
        "Stretch Snap": "Stretch Snap",
        "Suede": "Ante",
        "Sunglasses": "Gafas de sol",
        "T-Shirts": "Camisetas",
        "T-Shirts & Vests": "Camisetas y Chalecos",
        "Toddler": "2-4 años",
        "Tracksuits": "Conjunto chándal",
        "Trapper": "Gorra Trapper",
        "Trousers": "Pantalones",
        "Trucker": "Trucker",
        "Velour": "Terciopelo",
        "Visa Cash App Racing Bulls": "Visa Cash App RB Formula1 Team",
        "Visor Caps": "Gorras Viseras",
        "VR46": "VR46",
        "White": "Blanco",
        "Wool": "Lana",
        "Yellow": "Amarillo",
        "Youth": "6-12 años",
    };

    const fr_values = {
        "2-5": "35-38",
        "6-8": "39-42",
        "9-11": "43-46",
        "Adjustable": "Ajustable",
        "American Football": "Football Américain",
        "Bags": "Sacs",
        "Balaclava": "Cagoules",
        "Baseball": "Baseball",
        "Basketball": "Basketball",
        "Beige": "Beige",
        "Black": "Noir",
        "Blue": "Bleu",
        "Borg": "Borg",
        "Boucle": "Bouclé",
        "Box Fit": "Ajustée",
        "Boxing": "Boxe",
        "Brown": "Marron",
        "Buckets": "Bobs",
        "Button": "Bouton",
        "Buttons": "Butons",
        "Camo": "Camo",
        "Cap Carriers": "Malettes",
        "Cap Clips": "Clip de Casquette",
        "Child": "Enfant",
        "Cord": "Velours Côtelé",
        "Cream": "Crème",
        "Cricket": "Cricket",
        "Curved": "Courbée",
        "Dogear Caps": "Dogear",
        "Drawstring": "Cordon",
        "Dresses": "Robes",
        "Earmuffs": "Cache-oreilles",
        "Elasticated": "Élastique",
        "Faux Fur": "Fausse Fourrure",
        "Faux Suede": "Suède Synthétique",
        "Female": "Femme",
        "Fitted": "Ajusté",
        "Flat": "Plate",
        "Football": "Football",
        "French Federation Of Rugby": "Fédération Française de Rugby",
        "Gloves": "Gants",
        "Green": "Vert",
        "Grey": "Gris",
        "Heavy Twill": "Sergé Lourd",
        "Hoodies & Sweatshirts": "Sweats à Capuche & Pulls",
        "Infant": "Nourrison",
        "Jackets & Coats": "Vestes & Manteaux",
        "Joggers": "Joggings",
        "Key Rings": "Porte-clés",
        "Kids": "Enfant",
        "Knits": "Bonnets",
        "Leather": "Cuir",
        "Linen": "Lin",
        "Long": "Long",
        "Male": "Homme",
        "Melton Wool": "Laine Melton",
        "Merino Wool": "Laine Merino",
        "Mesh": "Mesh",
        "Misc": "Divers",
        "MLB Logo": "MLB Logo",
        "Motor Racing": "Motorsport",
        "NBA Logo": "NBA Logo",
        "NFL Logo": "NFL Logo",
        "No Visor": "Sans Visière",
        "One Size": "Taille unique",
        "Orange": "Orange",
        "Other": "Autres",
        "Oversized": "Oversize",
        "Pin Badges": "Pin's",
        "Pink": "Rose",
        "Ponytail Caps": "Open-back",
        "Popper": "Bouton-pression",
        "Portuguese Football Federation": "Fédération Portugaise de Football",
        "PU": "PU",
        "Purple": "Violet",
        "Red": "Rouge",
        "Regular": "Regular",
        "Repreve": "Repreve",
        "Ripstop": "Ripstop",
        "Rugby": "Rugby",
        "Satin": "Satin",
        "Scarves": "Écharpes",
        "Short": "Court",
        "Skull Beanie": "Bonnet",
        "Sleeveless": "Sans Manches",
        "Socks": "Chaussettes",
        "Stretch Fit": "Stretch",
        "Suede": "Suède",
        "Sunglasses": "Lunettes de Soleil",
        "T-Shirts & Vests": "T-shirts & Hauts",
        "Toddler": "Bébé",
        "Tracksuits": "Survêtements",
        "Trousers": "Pantalons",
        "Velour": "Velours",
        "Visor Caps": "Visières",
        "White": "Blanc",
        "Wool": "Laine",
        "Yellow": "Jaune",
        "Youth": "Junior",
        "Zip": "Fermeture éclair",
    };

    const filterTranslations = {
        "it": {
            "Category": it_values,
            "Categoria": it_values,
            "Clothing fit": it_values,
            "Vestibilità": it_values,
            "Colour": it_values,
            "Colore": it_values,
            "Fabric": it_values,
            "Materiale": it_values,
            "Fastening": it_values,
            "Chiusura": it_values,
            "Fit": it_values,
            "Retro": it_values,
            "Gender": it_values,
            "Genere": it_values,
            "Silhouette Type": it_values,
            "Silhouette": it_values,
            "Size": it_values,
            "Taglia": it_values,
            "Sleeve length": it_values,
            "Lunghezza Manica": it_values,
            "Sport": it_values,
            "Style": it_values,
            "Stile": it_values,
            "Team": it_values,
            "Visor Style": it_values,
            "Visiera": it_values,
            "Waist type": it_values,
            "Chiusura Girovita": it_values,
        },
        "de": {
            "Category": de_values,
            "Kategorie": de_values,
            "Clothing fit": de_values,
            "Passform": de_values,
            "Colour": de_values,
            "Farben": de_values,
            "Fabric": de_values,
            "Material": de_values,
            "Fastening": de_values,
            "Verschlussart": de_values,
            "Fit": de_values,
            "Gender": de_values,
            "Geschlecht": de_values,
            "Silhouette Type": de_values,
            "Silhouette": de_values,
            "Size": de_values,
            "Größen": de_values,
            "Sleeve length": de_values,
            "Ärmellänge": de_values,
            "Sport": de_values,
            "Style": de_values,
            "Team": de_values,
            "Visor Style": de_values,
            "Schirm Variante": de_values,
            "Waist type": de_values,
            "Bund": de_values,
        },
        "es": {
            "Category": es_values,
            "Categoría": es_values,
            "Clothing fit": es_values,
            "Colour": es_values,
            "Color": es_values,
            "Fabric": es_values,
            "Material": es_values,
            "Fastening": es_values,
            "Fit": es_values,
            "Tipo de Ajuste": es_values,
            "Gender": es_values,
            "Género ": es_values,
            "Género": es_values,
            "Silhouette Type": es_values,
            "Estilo de Gorra": es_values,
            "Size": es_values,
            "Talla": es_values,
            "Sleeve length": es_values,
            "Sport": es_values,
            "Deporte": es_values,
            "Style": es_values,
            "Team": es_values,
            "Equipo": es_values,
            "Visor Style": es_values,
            "Estilo de Visera ": es_values,
            "Estilo de Visera": es_values,
            "Waist type": es_values,
        },
        "fr": {
            "Category": fr_values,
            "Categorie": fr_values,
            "Clothing fit": fr_values,
            "Coupe": fr_values,
            "Colour": fr_values,
            "Couleur": fr_values,
            "Fabric": fr_values,
            "Matière": fr_values,
            "Fastening": fr_values,
            "Fermeture": fr_values,
            "Fit": fr_values,
            "Ajustement ": fr_values,
            "Ajustement": fr_values,
            "Gender": fr_values,
            "Genre": fr_values,
            "Silhouette Type": fr_values,
            "Silhouette": fr_values,
            "Size": fr_values,
            "Taille": fr_values,
            "Sleeve length": fr_values,
            "Longueur de manche": fr_values,
            "Sport": fr_values,
            "Style": fr_values,
            "Team": fr_values,
            "Équipe": fr_values,
            "Visor Style": fr_values,
            "Type de Visière": fr_values,
            "Waist type": fr_values,
            "Type de taille": fr_values,
        },
    };

    // SETTINGS END. DO NOT EDIT THE CODE BELOW.

    (function($) {
        function translateFacets(data, type) {
            const localeTranslations = filterTranslations[Shopify.locale];

            if (!localeTranslations || !data?.facets?.length || type !== 'results') return;

            for (f of data.facets) {
                if (localeTranslations[f?.title]) {
                    for (v of f.buckets) {
                        if (!v.title) v.title = v.value;
                        if (localeTranslations[f.title][v?.title]) {
                            v.title = localeTranslations[f.title][v.title];
                        }
                    }
                }
            }
        }

        $(document).on('Searchanise.DataRequestEnd', function(e, type, params, data) {
            translateFacets(data, type);
        });
    })(window.Searchanise.$);
});
